/* eslint-disable class-methods-use-this */
/**
 * Mennegat Trading.
 *
 * @author Robuust
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { ApplicationController, useDebounce } from 'stimulus-use';

/**
 * Products controller.
 */
export default class extends ApplicationController {
  static targets = ['filters', 'type'];

  static classes = ['open', 'expanded', 'hidden'];

  static debounces = ['submit'];

  /**
   * Connect.
   */
  connect() {
    useDebounce(this);
  }

  /**
   * Toggle filters.
   */
  filters() {
    this.filtersTarget.classList.toggle(this.openClass);
  }

  /**
   * Toggle types.
   *
   * @param {Event} e
   */
  types(e) {
    const button = e.target;
    const span = button.lastElementChild;
    span.textContent = e.params.toggle[span.textContent === e.params.toggle[0] ? 1 : 0];
    button.classList.toggle(this.expandedClass);
    this.typeTargets.forEach((type) => {
      type.classList.toggle(this.hiddenClass);
    });
  }

  /**
   * Request submit.
   *
   * @param {Event} e
   */
  submit(e) {
    if (e.key === 'Enter') return; // Ignore Enter key

    e.target.form.requestSubmit();
  }
}
